import { render, staticRenderFns } from "./deliverydashboard.vue?vue&type=template&id=2fb8a4d6"
import script from "./deliverydashboard.vue?vue&type=script&lang=js"
export * from "./deliverydashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports